module.exports = __webpack_public_path__ + "static/media/P3.55d52539.jpg";